import React, { useEffect, useState, useRef } from "react";

const NotificationApp = () => {
  const [delay, setDelay] = useState("0");
  const timeouts = useRef<any[]>([])

  const startNotify = async () => {
    if (Notification.permission !== "granted") {
      await Notification.requestPermission();
    }

    const delayNum = parseInt(delay) ?? 0

    timeouts.current.push(setTimeout(() => {
      new Notification(`ID: ${Math.round(Math.random() * 600000)}`, {
        body: "This is body",
        tag: Math.random() + ""
      });
    }, delayNum * 1000))
  };

  useEffect(() => {
    return () => {
      timeouts.current.forEach(timeout => clearTimeout(timeout))
    }
  })

  return (
    <>
      <h1 className="mt-20 mb-5 text-3xl">Notification App</h1>
      <div className="p-10 border border-gray-400 rounded-xl">
        <div>
          Delay:
          <input
            type="number"
            value={delay}
            onChange={e => setDelay(e.target.value)}
            className="rounded-md mx-2 px-4 py-1"
          />
          Seconds
        </div>
        <button
          onClick={startNotify}
          className="rounded-xl bg-green-600 text-white px-32 py-2 outline-none focus:outline-none mt-8"
        >
          {delay === "0" ? "Send instant notification" : "Send delayed notification"}
        </button>
      </div>
    </>
  );
};

export default NotificationApp;
